import React from "react";
import { MESSAGES } from "../../../../common/Messages";

// Every customer-scoped bottom tab (Collections History, Open Items, Cash Receipts,
// Transactions, Contact) shows the same "pick a customer first" message when the Followup
// tab has no customer yet - ARD0009 drove all of those grids off iCurrentCustomer too.
// One component so the wording and styling are defined once instead of copy-pasted per tab.
const SelectCustomerPlaceholder = ({ content }) => (
    <div style={{ padding: '16px' }}>{MESSAGES.FOLLOW_UP_SELECT_CUSTOMER.replace("{0}", content)}</div>
);

export default SelectCustomerPlaceholder;
